export default "__VITE_ASSET__9c157c6d__"